import React, { useState } from "react";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import styles from "./styles.module.css";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import SendIcon from "@mui/icons-material/Send";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import CircularProgress from "@mui/material/CircularProgress";
import InputMask from "react-input-mask";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ValidadorSenha from "../../components/ValidadorSenha";
import config from "../../config";
import { validarFormatacaoDocumento } from "../../services/validation.service"; // Ajuste o caminho conforme a localização real

import {
  enviarCodigoVerificacaoHandler,
  existeDuplicidade,
} from "../../services/auth.service";
import ResponsivContent from "../../components/ResponsivContent";

export const CadastroAssociado = () => {
  const [usuario, setUsuario] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");
  const [senhaCompleta, setSenhaCompleta] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState({
    documento: null,
    email: null,
    usuario: null,
  });
  const [helperText, setHelperText] = useState({
    email: "",
    documento: "",
    usuario: "",
  });
  const [status, setStatus] = useState({
    type: "",
    mensagem: "",
    loading: false,
  });
  const [tipoDocumento, setTipoDocumento] = useState("CPF");
  const [documento, setDocumento] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [placeholder, setPlaceholder] = useState("000.000.000-00");
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const navigate = useNavigate();

  const isValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChangeEmail = async (event) => {
    const value = event.target.value;
    setEmail(value);
    if (isValid(value)) {
      setError((prevState) => ({ ...prevState, email: false }));
      setHelperText((prevState) => ({ ...prevState, email: "" }));
    } else {
      setError((prevState) => ({ ...prevState, email: true }));
      setHelperText((prevState) => ({
        ...prevState,
        email: "Favor inserir um email válido",
      }));
    }
  };

  const handleChangeUsuario = (event) => {
    const formattedValue = event.target.value.replace(/\s/g, "").toLowerCase();
    setUsuario(formattedValue);
    
    // Atualiza o estado de erro se o usuário digitar espaços ou caracteres maiúsculos
    if (event.target.value.includes(" ") || formattedValue !== event.target.value) {
      setError((prevState) => ({ ...prevState, usuario: true }));
      setHelperText((prevState) => ({
        ...prevState,
        usuario: "O nome de usuário não pode conter espaços e deve estar em minúsculas.",
      }));
    } else {
   setError ((prevState)=> ({...prevState, usuario: false }));
      setHelperText((prevState) => ({ ...prevState, usuario: "" }));
    }
  };

  const handleChangeSenha = (event) => {
    setSenha(event.target.value);
  };

  const handleChangeConfirmaSenha = (event) => {
    setConfirmaSenha(event.target.value);
  };

  const handleTipoDocumentoChange = (event, value) => {
    if (value === "CPF") {
      setTipoDocumento(value);
      setPlaceholder("000.000.000-00");
    } else if (value === "CNPJ") {
      setTipoDocumento(value);
      setPlaceholder("00.000.000/9999-99");
    } else if (value === "RNE") {
      setTipoDocumento(value);
      setPlaceholder("A0000000-A");
    } else {
      setTipoDocumento("");
      setPlaceholder("");
    }
  };

  const handleOpenSnackbarSucesso = () => setOpenSnackbarSucesso(true);
  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => setOpenSnackbarErro(true);
  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const limparCampos = () => {
    setUsuario("");
    setEmail("");
    setSenha("");
    setConfirmaSenha("");
    setTipoDocumento("CPF");
    setDocumento("");
  };

  const validateDocument = async (value, tipo) => {
    const valiDoc = await validarFormatacaoDocumento(value, tipo);
    if (valiDoc) {
      const existeDocumentoCadastrado = await existeDuplicidade(
        tipo.toLowerCase(),
        value
      );
      return !existeDocumentoCadastrado.cadastrado;
    } else return false;
  };

  const handleValidate = async () => {
    let validacao = true;
    if (
      !(await validateDocument(documento.replace(/[.\-\/]/g, ""), tipoDocumento))
    ) {
      setHelperText((prevState) => ({
        ...prevState,
        documento: "Documento incorreto ou já consta na base.",
      }));
      setError((prevState) => ({ ...prevState, documento: true }));
      validacao = false;
    }

    if (senha !== confirmaSenha) {
      validacao = false;
    }

    if (error.email === true) {
      validacao = false;
    }

    if (!usuario || usuario === "") {
      setHelperText((prevState) => ({
        ...prevState,
        usuario: "O campo Usuario deve ser preenchido",
      }));
      setError((prevState) => ({ ...prevState, usuario: true }));
      validacao = false;
    }

    return validacao;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const hoje = new Date();
    const dtExpiracao = new Date(hoje);
    dtExpiracao.setFullYear(hoje.getFullYear() + 2);

    const formData = {
      usuario: {
        login: usuario,
        senha,
        nomeCompleto: null,
        dtExpiracao,
        email,
        cnpj:
          tipoDocumento === "CNPJ" ? documento.replace(/[.\-\/]/g, "") : null,
        cpf: tipoDocumento === "CPF" ? documento.replace(/[.\-]/g, "") : null,
        rne:
          tipoDocumento === "RNE"
            ? documento.replace(/[^a-zA-Z0-9]/g, "")
            : null,
        ativo: true,
        usuCadastro: 1,
      },
    };

    if (await handleValidate()) {
      try {
        const response = await axios.post(
          `${config.REACT_APP_HOST_API_AUTENTICACAO}/usuarios/planejamento-tributario/A`,
          formData
        );
        setMsg(response.data.mensagem);
        handleOpenSnackbarSucesso();
        await enviarCodigoVerificacaoHandler(email);
        navigate(`/validar-codigo-email?endereco=${email}`);
      } catch (error) {
        setMsg(error.response.data.mensagem);
        handleOpenSnackbarErro();
      }
    } else {
      setMsg("Um ou mais campos estão incorretos");
      handleOpenSnackbarErro();
    }
    setLoading(false);
  };

  return (
    <div className={styles.main}>
      <ResponsivContent>
        <div>
          <h2 className={styles.titulo}>Cadastro de Associado</h2>
        </div>
        <div className={styles.formCadastro}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <label className={styles.labelField}>Tipo de Documento:</label>
              <Autocomplete
                fullWidth
                className={styles.tipoDocumentoCombo}
                size="small"
                value={tipoDocumento}
                options={["CPF", "CNPJ", "RNE"]}
                onChange={handleTipoDocumentoChange}
                renderInput={(params) => <TextField {...params} label="" />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label className={styles.labelField}>CPF/CNPJ ou RNE:</label>
              <InputMask
                mask={
                  tipoDocumento === "CPF"
                    ? "999.999.999-99"
                    : tipoDocumento === "CNPJ"
                    ? "99.999.999/9999-99"
                    : tipoDocumento === "RNE"
                    ? "a9999999-a"
                    : ""
                }
                value={documento}
                onChange={(e) => setDocumento(e.target.value)}
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    className={styles.documentoTextField}
                    fullWidth
                    size="small"
                    variant="outlined"
                    type="text"
                    name="documento"
                    value={documento}
                    placeholder={placeholder}
                    error={error.documento}
                    helperText={helperText.documento}
                  />
                )}
              </InputMask>
            </Grid>
          </Grid>
          <div className={styles.containerUsuarioTextField}>
            <label className={styles.labelField}>Usuário:</label>
            <TextField
              className={styles.usuarioTextField}
              fullWidth
              size="small"
              variant="outlined"
              type="text"
              value={usuario}
              error={error.usuario}
              helperText={helperText.usuario}
              onChange={handleChangeUsuario}
              name="usuario"
              placeholder="joao.silva"
            />
          </div>
          <div className={styles.containerEmailTextField}>
            <label className={styles.labelField}>E-mail:</label>
            <TextField
              className={styles.emailTextField}
              fullWidth
              size="small"
              variant="outlined"
              type="text"
              onChange={handleChangeEmail}
              error={error.email}
              helperText={helperText.email}
              name="email"
              value={email}
              placeholder="joao.silva@dominio.com.br"
            />
          </div>
          <div className={styles.containerSenhaTextField}>
            <label className={styles.labelField}>Senha:</label>
            <OutlinedInput
              className={styles.senhaTextField}
              id="filled-adornment-password"
              type={showPassword ? "text" : "password"}
              size="small"
              fullWidth
              value={senha}
              onChange={handleChangeSenha}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <ValidadorSenha senha={senha} setSenhaCompleta={setSenhaCompleta} />
          </div>
          <div className={styles.containerConfirmarSenhaTextField}>
            <label className={styles.labelField}>Confirmação da senha:</label>
            <OutlinedInput
              className={styles.senhaTextField}
              id="filled-adornment-confirm-password"
              type={showPassword ? "text" : "password"}
              size="small"
              fullWidth
              value={confirmaSenha}
              onChange={handleChangeConfirmaSenha}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            {confirmaSenha && confirmaSenha !== senha ? (
              <p style={{ color: "red", fontSize: ".8rem" }}>
                As senhas devem ser idênticas!
              </p>
            ) : (
              ""
            )}
          </div>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4}>
              <Button
                fullWidth
                type="submit"
                disabled={!senhaCompleta || confirmaSenha !== senha}
                className={
                  senhaCompleta && confirmaSenha === senha
                    ? styles.botaoEnviar
                    : styles.botaoEnviar_disable
                }
                variant="contained"
                onClick={handleSubmit}
                sx={{ padding: "0.5rem", gap: "0.3rem", height: "2.3rem" }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  <>
                    <SendIcon />
                    Enviar
                  </>
                )}
              </Button>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Button
                fullWidth
                type="button"
                className={styles.botaoLimpar}
                variant="contained"
                onClick={limparCampos}
                sx={{ padding: "0.5rem", gap: "0.3rem", height: "2.3rem" }}
              >
                <PhonelinkEraseIcon />
                Limpar
              </Button>
            </Grid>
          </Grid>
        </div>

        {status.type === "error" ? (
          <p className={styles.mensagemUsuario}>{status.mensagem}</p>
        ) : (
          ""
        )}
        {status.type === "success" ? (
          <p className={styles.mensagemUsuario}>{status.mensagem}</p>
        ) : (
          ""
        )}
        {status.loading ? (
          <p className={styles.mensagemUsuario}>Carregando...</p>
        ) : (
          ""
        )}
        <CardActions></CardActions>
      </ResponsivContent>
      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};
